import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import calculateDuration from '@justpark/helpers/src/calculateDurationDayjs/calculateDuration';
import getDayjsInstance from './dates/getDayjsInstance';

dayjs.extend(advancedFormat);

export const todayTomorrowDateFormat = (
  date: Dayjs,
  year: boolean = false,
  hideTime: boolean = false,
  t: (string, string) => void
) => {
  if (!date) {
    return '';
  }
  const dayjsInstance = getDayjsInstance();

  if (date.isSame(dayjsInstance, 'day')) {
    return hideTime
      ? t('dateFormat:today', '{{date, [Today]}}', { date })
      : t('dateFormat:todayAt', '{{date, [Today at] HH:mm}}', { date });
  }

  if (date.isSame(dayjsInstance.add(1, 'days'), 'day')) {
    return hideTime
      ? t('dateFormat:tomorrow', '{{date, [Tomorrow]}}', { date })
      : t('dateFormat:tomorrowAt', '{{date, [Tomorrow at] HH:mm}}', { date });
  }

  if (hideTime) {
    return year
      ? t('dateFormat:dateMonthYear', '{{date,D MMM YYYY}}', { date })
      : t('dateFormat:dateMonth', '{{date,Do MMM}}', { date });
  }

  return year
    ? t('dateFormat:dateMonthYearTime', '{{date,D MMM YYYY [at] HH:mm}}', {
        date
      })
    : t('dateFormat:dateMonthTime', '{{date,Do MMM [at] HH:mm}}', { date });
};

export const formatDurationFromSeconds = (
  seconds: number,
  t: (string, string) => string
) =>
  calculateDuration(
    getDayjsInstance(),
    getDayjsInstance().add(seconds, 'seconds'),
    false,
    t
  );

export const defaultSearchDates = () => {
  const now = getDayjsInstance();
  const arriving = now.add(59, 'minutes').startOf('hour');
  const leaving = arriving.add(2, 'hours');

  return {
    arriving,
    leaving
  };
};

export default null;
